import commonCustomModalCSS from '@assets/css/common-custom-modal.css';

/**
 * Common custom modal styles.
 * @type {CSSStyleSheet}
 */
export const commonCustomModalStyles = new CSSStyleSheet();
commonCustomModalStyles.replaceSync(commonCustomModalCSS);
